/**
 * Await a dispatched thunk promise and run optional UI handlers.
 * Actions should reject/throw on failure so onFailure runs (and onSuccess does not).
 * Always settles so fire-and-forget callers do not leave unhandled rejections.
 */
export const handleAsyncAction = async (
  promise,
  { onSuccess, onFailure } = {},
) => {
  try {
    const result = await promise;
    onSuccess?.(result);
    return result;
  } catch (error) {
    onFailure?.(error);
  }
};
